export default "__VITE_ASSET__d9735d59__"